// Combined document ready calls
$(document).ready(function() {
    // Scroll to top if no hash is present
    if (!window.location.hash) {
        window.scrollTo(0, 0);
    }

    // Clear UTM parameters
    function clearUtmParams() {
        setTimeout(function() {
            if (!window.history.replaceState) return;
            var cleanSearch = window.location.search
                .replace(/utm_[^&]+&?/g, '')
                .replace(/&$/, '')
                .replace(/^\?$/, '');
            window.history.replaceState({}, '', window.location.pathname + cleanSearch);
        }, 3000);
    }
    window.addEventListener('load', function() {
        if (typeof ga !== 'undefined' || typeof analytics !== 'undefined') {
            if (typeof analytics !== 'undefined') {
                analytics.ready(clearUtmParams);
            } else if (ga.loaded) {
                clearUtmParams();
            } else {
                ga(clearUtmParams);
            }
        } else {
            setTimeout(clearUtmParams, 1000);
        }
    });
  
    // Countdown timer bar
    function startCountdown(endDate) {
        function updateTimer() {
            const now = new Date().getTime();
            const distance = endDate - now;
            if (distance < 0) {
                clearInterval(interval);
                $("#countdown-timer-bar").hide();
                return;
            }
            const days = formatNumber(Math.floor(distance / (1000 * 60 * 60 * 24)));
            const hours = formatNumber(Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
            const minutes = formatNumber(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)));
            const seconds = formatNumber(Math.floor((distance % (1000 * 60)) / 1000));
            $("#days").text(days);
            $("#hours").text(hours);
            $("#minutes").text(minutes);
            $("#seconds").text(seconds);
        }
        const interval = setInterval(updateTimer, 1000);
        updateTimer();

        // Helper function to format numbers with leading zero
        function formatNumber(num) {
            return num < 10 ? "0" + num : num;
        }
    }
    const saleEndDate = new Date("2024-12-09T23:59:59").getTime();
    startCountdown(saleEndDate);

    // Delivery status
    function updateOrderDetails(country) {
        let isDomestic = country === "US";
        let daysToAdd = isDomestic ? 5 : 10;
        let today = new Date();
        let arrivalDate = new Date();
        arrivalDate.setDate(today.getDate() + daysToAdd);
        let options = { month: "short", day: "numeric" };
        let formattedDate = arrivalDate.toLocaleDateString("en-US", options);
        $(".arrival-date .stacked-text strong").text(formattedDate);
        $(".order-arrow .label").text(isDomestic ? "Domestic" : "International");
    }
    $.get("https://ipapi.co/json/", function(data) {
        if (data && data.country) {
            updateOrderDetails(data.country);
        } else {
            updateOrderDetails("International");
        }
    }).fail(function() {
        updateOrderDetails("International");
    });

    // Add Variant Price to Add to Cart Button
    $('.product-block').each(function () {
      const $block = $(this);
      const $buttonText = $block.find('button[data-add-to-cart] span[data-add-to-cart-text]');
      const defaultText = $buttonText.data('default-text');
      const updatePrice = () => {
        const price = $block.find('.product-single__variants :selected').data('price') || $block.data('price') || '';
        $buttonText.text(`${defaultText} • ${price}`);
      };
      $block.find('.product-single__variants').on('change', updatePrice).trigger('change');
    });
/*
    // Add to Cart and Update UI Script
    if (!window.location.href.includes('mini-handheld-fan')) {
        $(document).on("click", '.btn.btn--full.add-to-cart', function(event) {
            event.preventDefault();
            event.stopPropagation();
            var productDataElement = document.querySelector('[data-product-x-json]');
            if (!productDataElement) return;
            var product = JSON.parse(productDataElement.getAttribute('data-product-x-json'));
            const $addToCartButton = $(this).addClass("btn--loading");
            const variantId = parseInt($('[name="id"]').val());
            $.post('/cart/add.js', { id: variantId, quantity: 1 })
                .done(function(data) {
                    $.getJSON('/cart/', function(cart) {
                        const updates = {};
                        cart.items.forEach(function(item) {
                            if (product.handle === item.handle) {
                                updates[item.id] = 0;
                            }
                        });
                        updates[variantId] = 1;
                        $.post('/cart/update.js', { updates }).done(function() {
                            updateCartUI($addToCartButton);
                        });
                    });
                });
        });
    }
    function updateCartUI($addToCartButton) {
        $addToCartButton.removeClass("btn--loading");
        $('.cart-link').click();
        new theme.CartDrawer();
    }
*/
    // Ingredients list modal
    function showModal() {
        $('#ingredients-modal').show();
    }
    function hideModal() {
        $('#ingredients-modal').hide();
    }
    $('#view-ingredients-link').click(function(e) {
        e.preventDefault();
        showModal();
    });
    $('.close-modal').click(hideModal);
    $('#ingredients-modal').click(function(e) {
        if ($(e.target).is('#ingredients-modal')) {
            hideModal();
        }
    });
    if (window.location.hash === '#ing') {
        showModal();
    }

    // Canvas Confetti
    const addToCartButtons = document.getElementsByClassName("confetti-button");
    for (let i = 0; i < addToCartButtons.length; i++) {
        addToCartButtons[i].addEventListener("click", function() {
            confetti({
                particleCount: 100,
                spread: 70,
                origin: { y: 0.6 },
            });
        });
    }

    // Live cart
    let lastNumber = Math.floor(Math.random() * 21) + 50;
    function showPeopleInCart() {
        const changes = [1, 2, 4];
        const change = changes[Math.floor(Math.random() * changes.length)] * (Math.random() < 0.5 ? 1 : -1);
        lastNumber += change;
        if (lastNumber < 50) lastNumber = 50;
        if (lastNumber > 70) lastNumber = 70;
        const message = `${lastNumber} shoppers have this in their carts right now`;
        $('#cartMessage').text(message);
        const randomTimeout = Math.floor(Math.random() * 8000) + 2000;
        setTimeout(showPeopleInCart, randomTimeout);
    }
    showPeopleInCart();

    // Today's shoppers
    (function() {
        const startCount = 50;
        const endCount = 1489;
        const totalUpdates = 24 * 60;
        const increment = (endCount - startCount) / totalUpdates;
        function getMinutesSinceMidnight() {
            const now = new Date();
            return now.getHours() * 60 + now.getMinutes();
        }
        const elapsedMinutes = getMinutesSinceMidnight();
        let currentCount = Math.min(startCount + elapsedMinutes * increment, endCount);
        const peopleCountElement = $('#people-count');
        function updatePeopleViewing() {
            currentCount = Math.min(currentCount + increment, endCount);
            peopleCountElement.text(Math.floor(currentCount));
        }
        if (peopleCountElement.length) {
            peopleCountElement.text(Math.floor(currentCount));
            setInterval(updatePeopleViewing, 60000);
        }
    })();

    // Free shipping progress bar cart drawer
    const shippingLimit = 75;
    const discountLimitValue = "99";
    const couponCodeValue = "SAVE10";
    const discountLimit = parseInt(discountLimitValue);
    function calculateProgress(cartTotal) {
        let progress;
        if (cartTotal < shippingLimit) {
            progress = (cartTotal / shippingLimit) * 50;
        } else {
            progress = 50 + ((cartTotal - shippingLimit) / (discountLimit - shippingLimit)) * 50;
        }
        return Math.min(progress, 100);
    }
    function updateMessage(progress, cartTotal) {
        if (cartTotal >= shippingLimit) {
            if (progress >= 100) {
                $('.coupon-code').html(`Coupon code: <span data-coupon-code-value="${discountLimitValue}" style="color:#fff;">${couponCodeValue}</span>`);
                $('.coupon-code').show();
                return 'Yaay! You qualify for a <strong>10% DISCOUNT</strong> + <strong>FREE SHIPPING</strong>!';
            }
            $('.coupon-code').hide();
            return 'Now $' + (discountLimit - cartTotal) + ' away from a <strong>10% DISCOUNT</strong>!';
        } else {
            $('.coupon-code').hide();
            return '$' + (shippingLimit - cartTotal) + ' away from <strong>FREE SHIPPING</strong>!';
        }
    }
    function getOriginalCartTotal() {
        return new Promise((resolve) => {
            $.getJSON('/cart.js', function(cart) {
                const originalCartTotal = Math.round(cart.original_total_price / 100);
                resolve(originalCartTotal);
            });
        });
    }
    new MutationObserver(async function() {
        const cartTotal = await getOriginalCartTotal();
        const progress = calculateProgress(cartTotal);
        $('.progress-bar').css('width', progress + '%');
        if (progress >= 100) {
            $('.progress-bar').addClass('full');
        } else {
            $('.progress-bar').removeClass('full');
        }
        $('.progress-text').html(updateMessage(progress, cartTotal));
    }).observe($('[data-subtotal]')[0], { childList: true });
    $('[data-subtotal]').trigger('change');
    let canClick = true;
    $('.coupon-code').on('click', function(event) {
        if (!canClick) {
            return;
        }
        event.stopPropagation();
        const couponCode = $(this).find('[data-coupon-code-value]').text();
        const textarea = $('<textarea></textarea>');
        $('body').append(textarea);
        textarea.val(couponCode).select();
        document.execCommand('copy');
        textarea.remove();
        $(this).text('Coupon copied. Use at checkout!');
        canClick = false;
        setTimeout(() => {
            $(this).html(`Coupon code: <span data-coupon-code-value="${discountLimitValue}" style="color:#fff;">${couponCodeValue}</span>`);
            canClick = true;
        }, 2000);
    });

    // Smooth scroll for all anchor links
    $('a[href^="#"]').on('click', function(event) {
        var target = $(this.getAttribute('href'));
        if (target.length) {
            event.preventDefault();
            var isMobile = $(window).width() <= 767;
            var baseOffset = (target.attr('id') === "OrderYours") ? (isMobile ? 300 : -100) : 0;
            $('html, body').stop().animate({
                scrollTop: target.offset().top + baseOffset
            }, 1000);
        }
    });

    // Show or hide "order now" button based on scroll position
    var scrollOffset = (typeof template !== 'undefined' && template === 'index') ? 400 : 1000;
    var duration = 200;
    $(window).scroll(function() {
        if ($(this).scrollTop() > scrollOffset) {
            $('#order-now-button').fadeIn(duration).addClass('show');
        } else {
            $('#order-now-button').fadeOut(duration).removeClass('show');
        }
    });
});